module.exports = __webpack_public_path__ + "static/media/maintenance-2.9745adfe.jpg";